import { render, staticRenderFns } from "./UiCarousels.vue?vue&type=template&id=aa017a68&"
import script from "./UiCarousels.vue?vue&type=script&lang=js&"
export * from "./UiCarousels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports